import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import FormikDatePicker from '../formik-fields/FormikDatePicker.jsx';

const GridFormikDatePicker = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikDatePicker { ...props } />
    </Grid>
  );
};

GridFormikDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object.isRequired,
};

export default GridFormikDatePicker;
